import {
  ImpactShopBasketProduct,
  ImpactShopCheckoutProduct,
  Currency,
} from "@ecologi/shared";
import { GetState, SetState } from "zustand";
import { useFetchImpactShopStore } from "./impact-shop";
import {
  ImpactShopMessage,
  IMPACT_SHOP_MESSAGES,
} from "../features/impact-shop/constants";

export enum UtmParamKey {
  UTM_SOURCE = "utm_source",
  UTM_MEDIUM = "utm_medium",
  UTM_CAMPAIGN = "utm_campaign",
  UTM_CONTENT = "utm_content",
  UTM_TERM = "utm_term",
  UTM_ID = "utm_id",
  GCLID = "gclid",
}

export type UtmParams = {
  [UtmParamKey.UTM_SOURCE]?: string;
  [UtmParamKey.UTM_MEDIUM]?: string;
  [UtmParamKey.UTM_CAMPAIGN]?: string;
  [UtmParamKey.UTM_CONTENT]?: string;
  [UtmParamKey.UTM_TERM]?: string;
  [UtmParamKey.UTM_ID]?: string;
  [UtmParamKey.GCLID]?: string;
};

export type ImpactShopState = {
  basket: ImpactShopBasketProduct[];
  currency: Currency;
  message?: ImpactShopMessage;
  utmParams: UtmParams;
};

type ImpactShopGetters = {
  totalCostOfProduct: (product: ImpactShopBasketProduct) => number;
  totalNumberOfProductsInBasket: () => number;
  totalPriceOfBasket: () => number;
  unitPriceOfProduct: (product: ImpactShopBasketProduct) => number;
  basketProductsWithCurrency: () => {
    products: ImpactShopCheckoutProduct[];
    currency: Currency;
  };
};

type ImpactShopSetters = {
  addProductToBasket: (product: ImpactShopBasketProduct) => void;
  clearMessage: () => void;
  emptyBasket: () => void;
  incrementProductQuantity: (
    productToUpdate: ImpactShopBasketProduct,
    amount: number
  ) => void;
  removeProductFromBasket: (product: ImpactShopBasketProduct) => void;
  setCurrency: (currency: Currency) => void;
  setProductFundedByAs: (
    productToUpdate: ImpactShopBasketProduct,
    fundedBy: string
  ) => void;
  setProductGroupAs: (
    productToUpdate: ImpactShopBasketProduct,
    groupId: number | null
  ) => void;
  setProductQuantityAs: (
    productToUpdate: ImpactShopBasketProduct,
    amount: number
  ) => void;
  setUtmParams: (utmParams: UtmParams) => void;
};

export type ImpactShopStore = ImpactShopState &
  ImpactShopGetters &
  ImpactShopSetters;

export type CreateImpactShopGetters = (
  get: GetState<ImpactShopStore>
) => ImpactShopGetters;

export type CreateImpactShopSetters = (
  set: SetState<ImpactShopStore>
) => ImpactShopSetters;

export type UseImpactShopStore = ReturnType<typeof useFetchImpactShopStore>;
